'use client';
import { useCarouselState } from '@repo/ui/src/hooks/useCarouselState';
import { classNames } from '@repo/ui/src/utils/classNames';
import { Slide } from 'pure-react-carousel';
import React from 'react';

interface SlideWrapperProps {
  children: React.ReactNode;
  index: number;
  length: number;
  className?: string;
}

const SlideWrapper = ({ children, index, length, className }: SlideWrapperProps) => {
  const state = useCarouselState();

  const _isVisible = state
    ? index >= Math.floor(state.currentSlide) &&
      index < Math.ceil(state.currentSlide + state.visibleSlides)
    : true;

  const [isVisible, setIsVisible] = React.useState(_isVisible);
  React.useEffect(() => {
    if (_isVisible) {
      setIsVisible(true);
    } else {
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 400);
      return () => window.clearTimeout(timer);
    }
  }, [_isVisible]);

  return (
    <Slide
      index={index}
      key={index}
      role='group'
      tabIndex={-1}
      className={classNames(className, !isVisible && 'tw-invisible')}
      aria-label={`slide ${index + 1} of ${length}`}
      aria-hidden={!isVisible}
    >
      {children}
    </Slide>
  );
};

export default SlideWrapper;
